import { SettingsChangeEvent, settingsChangeTopic } from 'apprise-core/settings'
import { useT } from 'apprise-frontend-core/intl/language'
import { EventSubscriber } from "apprise-frontend-events/subscriptions"
import { useReloadOnEvent } from 'apprise-frontend-events/utils'
import { defaultDrawerParam } from 'apprise-ui/header/actionmenu'
import { useLazyRouting } from 'apprise-ui/utils/routing'
import { settingsParamValue, settingsType } from './constants'
import { useSettingsClientCache } from "./context"


export const ChangeObserver = () => {

   const state = useSettingsClientCache()

    const t = useT()

    const inform = useReloadOnEvent({ singular: t('settings.title') })

    const routing = useLazyRouting()
   
    const listener = {

        topic: settingsChangeTopic

        ,

        onEvent: (event: SettingsChangeEvent) => {

            const { settings } = event

            console.log("updating settings on event notification...", { settings })

            const updateState = () => state.set(s => s.all = settings) 

            if (routing.get().query().includes(`${defaultDrawerParam}=${settingsParamValue}`))
                inform.thenRun(updateState)
            else
                updateState()

            

            // todo: should we remount the current route if it's protected by an EventGuard?
            // seems a bit extreme, at least until event guards become selective.
            // the guard may be there for other types of events that impact specific routes.

            // const { url, routeTo } = routing.get()            
            // routeTo( url(), shortid())



        }
    }
    return <EventSubscriber name={settingsType} subscriptions={[listener]} />
}


